import React, { FC, useEffect, useState } from "react";
import { YhFormItemsBox } from "@/components/YhFormBox";
import { IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { customerService } from "@/views/base/customer/customerService";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useSalesDetailModel } from "../salesDetailModel";
import useGlobalModel from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { ISalesTabEnum } from "@/views/sales/salesTypes";
import { formatNum } from "@/utils/utils";
import { ISelectOptions } from "@/types/AppTypes";
import { salesService } from "@/views/sales/salesService";

export const BaseFormBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        addFormVal,
        editFormVal,
        updateFormVal,
        exchangeRateChange,
        getOfferDetail,
        getcurrencySymbol
    } = useSalesDetailModel(({ addFormVal, editFormVal }) => [addFormVal, editFormVal]);
    const { fetchCustomerList, fetchOfferList } = useGlobalModel(() => []);
    const { getSelectedDictOne } = useDictModel(() => []);
    const { beShopDs, user: { shopCode, },isEditable } = useGlobalModel(({ beShopDs, user }) => [beShopDs, user]);
    const formVal = mode === "edit" ? editFormVal : addFormVal;

    const [creditList, setCreditList] = useState<ISelectOptions[]>();

    const getCreditList = async () => {
        let { retData } = await salesService.creditPage({
            shopCode,
            "page": {
                "pageSize": 10000,
                "pageNum": 1
            }
        })
        const { records, ...pg } = retData;
        setCreditList(records?.map((item) => ({ label: item.code, value: item.code, key: item.id })) ?? [])
    }
    useEffect(() => {
        getCreditList()
    }, [])
    //回显选中客户带出来的数据
    const getCustomer = async (id: string) => {
        let { retData } = await customerService.one(id);
        let data = {
            customerCode: retData.code,
            customerName: retData.name,
            customerId: retData.id,
            phone: retData.phone,
            contact: retData.contact,
            source: retData.source,
        }
        updateFormVal(mode, data)
    }

    //客户选中
    const customerChange = (value: string, option: ISelectOption) => {
        if (option && option.id) {
            getCustomer(option.id as string)
        }
    }

    //报价单选中
    const offerChange = (value: string, option: ISelectOption) => {
        debugger
        if (option && option.value) {
            getOfferDetail(option.value as string)
        }
    }

    //币种选中
    const currencyChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { currencyCode: option.value, currencyName: option.label });
    }
    //国别选中
    const countryChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { countryCode: option.value, countryName: option.label });
    }
    //出口商
    const bentityChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { bentityCode: option.value, bentityName: option.label });
    }
    //汇率失焦
    const exchangeRateBlur = (fieldName: string) => {
        let { exchangeRate } = formVal;
        if (!exchangeRate) return;
        //匹配正则就修改加收费用  及 商品明细的单价
        if (/^[0-9]+(.[0-9]{0,5})?$/.test(`${exchangeRate}`)) {
            exchangeRateChange(mode, +exchangeRate)
        }
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "外贸合同号",
                fieldName: "realCode",
                disable:formVal.status==='sales.ship'
            },
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: <span onClick={() => { console.log(formVal) }}>客户名称</span>,
                fieldName: "customerCode",
                onSelectChange: customerChange,
                placeholder: "客户",
                rules: [{ required: true, message: "请选择客户" }],
                selectfetchList: fetchCustomerList,
                // disable:mode === "add" 
                disable:formVal.status==='sales.ship',
                defaultQuery: formVal.customerName
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                disable:formVal.status==='sales.ship'
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "贸易国别",
                fieldName: "countryCode",
                onSelectChange: countryChange,
                options: getSelectedDictOne(DictCodeEnmu.COUNTRY),
                rules: [{ required: true, message: "请选择贸易国别" }],
                disable:formVal.status==='sales.ship'
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "签约日期",
                fieldName: "offerTime",
                disable:formVal.status==='sales.ship'
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "交货日期",
                fieldName: "termTime",
                disable:formVal.status==='sales.ship'
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                disable:formVal.status==='sales.ship'
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "保险",
                fieldName: "insure",
                disable:formVal.status==='sales.ship'
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "币种",
                fieldName: "currencyCode",
                onSelectChange: currencyChange,
                options: getSelectedDictOne(DictCodeEnmu.CURRENCY),
                disable:formVal.status==='sales.ship'
            },
            //  {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "人民币金额",
            //     fieldName: "rmbAmount",
            //     disable: true
            // }, 
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "出口商",
                fieldName: "bentityCode",
                onSelectChange: bentityChange,
                options: beShopDs,
                disable:formVal.status==='sales.ship'
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "货值金额",
                fieldName: "goodsAmount",
                prefix: getcurrencySymbol(mode),
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "附加费",
                fieldName: "addAmount",
                prefix: getcurrencySymbol(mode),
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "合同总金额",
                fieldName: "contractAmount",
                prefix: getcurrencySymbol(mode),
                disable: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "报价单号",
                fieldName: "offerCode",
                hidden:true
            },
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "报价单号",
                fieldName: "offerRealCode",
                onSelectChange: offerChange,
                rules: [{ required: true, message: "请选择报价单号" }],
                selectfetchList: fetchOfferList,
                defaultQuery: formVal.offerRealCode,
                disable: mode === "edit"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "汇率",
                fieldName: "exchangeRate",
                onInputBlur: exchangeRateBlur,
                rules: [{ required: true, message: "请输入汇率" }, { pattern: /^[0-9]+(.[0-9]{0,5})?$/, message: '请输入数字且可保留五位小数' }],
                disable:formVal.status==='sales.ship'
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "出库日期",
            //     fieldName: "deliveryTime",
            //     disable: true
            // },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "发运日期",
                fieldName: "shippingTime",
                disable:formVal.status==='sales.ship'
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: isEditable
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "收汇日期",
                fieldName: "settlementTime",
                // disable: false
                disable:formVal.status==='sales.ship'
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "结汇日期",
                fieldName: "payTime",
                // disable: false
                disable:formVal.status==='sales.ship'
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属部门",
                fieldName: "shopName",
                hidden: true,
                
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: isEditable
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务",
                fieldName: "reckoner",
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "信用证号",
                fieldName: "creditCode",
                options: creditList,
                disable:formVal.status==='sales.ship'
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "预计收款时间",
                fieldName: "estimatedTime",
                disable:formVal.status==='sales.ship'
            },
            //带出
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "国别名称",
                fieldName: "countryName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "货币名称",
                fieldName: "currencyName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "出口商名称",
                fieldName: "bentityName",
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "来源",
                fieldName: "source",
                hidden: true
            },
        ]
    };




    return (
        <YhFormItemsBox {...baseFormItem} />
    )
}